import { forwardRef } from 'react';
import * as icons from '@ant-design/icons';
import { createElement } from 'react';
const Icon = (props, ref) => {
    const { type = '', size, color, ...rest } = props;
    const IconComp = (icons || {})[type];
    const style = {
        ...rest.style,
        fontSize: size,
        color,
    };
    return createElement(IconComp, { ...rest, style: style, twoToneColor: color, ref: ref });
};
export default forwardRef(Icon);
